module.exports = __webpack_public_path__ + "media/images/favicon-a8993fe38950f59a55b33acf7ed6e3d8.jpeg";